import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LOGIN_ADMIN_ONLY, HIKE_PAGE_ONLY } from '../config';

export default function Navbar() {
  const { user, logout, hasPermission, totalPendingRequests } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="bg-blue-600 text-white border-b border-blue-700">
      <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center">
        {HIKE_PAGE_ONLY ? (
          <span className="text-base font-semibold truncate">
            Club Alpino Italiano Sezione di Modena
          </span>
        ) : (
          <Link
            to="/"
            className="text-base font-semibold hover:opacity-90 transition truncate"
          >
            Club Alpino Italiano Sezione di Modena
          </Link>
        )}

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Link
                to="/my-hikes"
                className={`px-3 py-1.5 rounded text-sm transition relative ${
                  location.pathname === '/my-hikes'
                    ? 'bg-blue-700'
                    : 'hover:bg-blue-700'
                }`}
              >
                Le Mie Gite
                {hasPermission('hike:create') && totalPendingRequests > 0 && (
                  <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full border border-white" />
                )}
              </Link>
              {hasPermission('hike:create') && (
                <Link
                  to="/create-hike"
                  className={`px-3 py-1.5 rounded text-sm font-medium transition ${
                    location.pathname === '/create-hike'
                      ? 'bg-yellow-500 text-yellow-900'
                      : 'bg-yellow-500 hover:bg-yellow-400 text-yellow-900'
                  }`}
                >
                  + Crea Gita
                </Link>
              )}
              {hasPermission('hike:view_hidden:any') && (
                <Link
                  to="/archived-hikes"
                  className={`px-3 py-1.5 rounded text-sm transition ${
                    location.pathname === '/archived-hikes'
                      ? 'bg-blue-700'
                      : 'hover:bg-blue-700'
                  }`}
                >
                  Archivio
                </Link>
              )}
              {hasPermission('system:admin') && (
                <Link
                  to="/admin"
                  className={`px-3 py-1.5 rounded text-sm font-medium transition ${
                    location.pathname === '/admin'
                      ? 'bg-purple-600 text-white'
                      : 'bg-purple-600 hover:bg-purple-700 text-white'
                  }`}
                >
                  Admin Panel
                </Link>
              )}
              <div className="flex items-center gap-2 ml-2 pl-2 border-l border-blue-500">
                <Link
                  to="/my-account"
                  className={`px-3 py-1.5 rounded text-sm transition flex items-center gap-1.5 ${
                    location.pathname === '/my-account'
                      ? 'bg-blue-700'
                      : 'hover:bg-blue-700'
                  }`}
                  title={`${user.nome} ${user.cognome}`}
                >
                  <span className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center text-xs font-medium">
                    {user.nome.charAt(0)}
                  </span>
                  <span className="hidden sm:inline">{user.nome}</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="px-3 py-1.5 bg-red-500 rounded text-sm hover:bg-red-600 transition"
                >
                  Esci
                </button>
              </div>
            </>
          ) : (
             !LOGIN_ADMIN_ONLY && !HIKE_PAGE_ONLY && (
               <Link
                 to="/login"
                 className="px-4 py-1.5 bg-white text-blue-600 rounded text-sm hover:bg-gray-100 transition font-medium"
               >
                 Login / Registrati
               </Link>
             )
           )}
        </div>
      </div>
    </nav>
  );
}